import { LOCAL_STORAGE } from '@constants';

const buildLoginDestination = () => {
  const destination: { pathname: string; state?: any } = { pathname: '/login' };

  const skipLoginRedirection = localStorage.getItem(LOCAL_STORAGE.SKIP_LOGIN_REDIRECTION);
  localStorage.removeItem(LOCAL_STORAGE.SKIP_LOGIN_REDIRECTION);

  // Remove trailing slash in pathname
  let { pathname } = window.location;
  pathname = `/${pathname.split('/').filter(Boolean).join('/')}`;

  if (skipLoginRedirection !== 'true' && !['/', '/home'].includes(pathname)) {
    destination.state = {
      redirectPath: pathname,
      redirectSearch: window.location.search,
      redirectHash: window.location.hash,
    };
  }

  return destination;
};

export default buildLoginDestination;
